import * as yup from 'yup'
import { mediaSchema } from '@/components/inputs'
import { OTHER_SPECIE_OPTION_VALUE } from '../fieldsOptions'

export const schema = yup.object({
  specie: yup.string().required(),
  other_specie: yup.string().when('specie', {
    is: OTHER_SPECIE_OPTION_VALUE,
    then: (schema) => schema.required(),
  }),
  specie_category: yup.string().required(),
  include_or_exclude: yup.string().required(),
  explanation: yup.string().optional(),
  notes: yup.string().max(256),
  photos: mediaSchema,
})
